import { render } from "./traCourseUploadVideo.vue?vue&type=template&id=98cef79e&scoped=true"
import script from "./traCourseUploadVideo.vue?vue&type=script&lang=js"
export * from "./traCourseUploadVideo.vue?vue&type=script&lang=js"

import "./traCourseUploadVideo.vue?vue&type=style&index=0&id=98cef79e&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98cef79e"]])

export default __exports__